import { render, staticRenderFns } from "./student-answer.vue?vue&type=template&id=ca02cf0c&scoped=true"
import script from "./student-answer.vue?vue&type=script&lang=js"
export * from "./student-answer.vue?vue&type=script&lang=js"
import style0 from "./student-answer.vue?vue&type=style&index=0&id=ca02cf0c&prod&lang=less&scoped=true"
import style1 from "./student-answer.vue?vue&type=style&index=1&id=ca02cf0c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca02cf0c",
  null
  
)

export default component.exports